<template>
    <v-container>
        <v-layout column>
            <v-flex>
                <v-btn color="primary" 
                @click="populateIssuesMaster()">POPULATE ISSUES MASTER</v-btn>
               
            </v-flex>

            <v-flex mt-5>
                <v-btn color="primary" 
                @click="populateIssueSubtypes()">POPULATE ISSUE SUBTYPES</v-btn>
               
            </v-flex>

            <v-flex mt-5>
                <v-btn color="primary" 
                @click="populateDiagnostics()">POPULATE DIAGNOSTICS </v-btn>
               
            </v-flex>

            <v-flex mt-5>
                <v-btn color="primary" 
                @click="populateLocations()">POPULATE LOCATIONS </v-btn>
               
            </v-flex>

            <v-flex mt-5>
                <v-btn color="primary" 
                @click="populateSections()">POPULATE SECTIONS </v-btn>
               
            </v-flex>

            <v-flex mt-5>
                <v-btn color="primary" 
                @click="populateSolutionMethods()">POPULATE SOLUTION METHODS </v-btn>
               
            </v-flex>

            <v-flex mt-5>
                <v-btn color="primary" 
                @click="populateSolutions()">POPULATE SOLUTIONS </v-btn>
               
            </v-flex>

        </v-layout>
    </v-container>
</template>
<script>

const fb = require('../../firebaseConfig.js')
export default {
    data(){
        return {

        }
    },
    methods:{
        populateIssuesMaster(){

            let issues = [
                {issue:'Table Lock',issueSubtype:'',issueType:'Software',idx:1},
                {issue:'Defective Printer',issueSubtype:'Printer',issueType:'Hardware',idx:2},
                {issue:'No Internet',issueSubtype:'',issueType:'Internet',idx:3},
                {issue:'No Network',issueSubtype:'',issueType:'Hardware',idx:4},
                {issue:'Blue Screen',issueSubtype:'',issueType:'Hardware',idx:5},
                {issue:'Request Install',issueSubtype:'',issueType:'Software',idx:6},
                {issue:'Expired License',issueSubtype:'',issueType:'Software',idx:7},
                {issue:'OS Upgrade',issueSubtype:'',issueType:'Software',idx:8},
                {issue:'Virus Attack',issueSubtype:'',issueType:'Software',idx:9},
                {issue:'Sync Error',issueSubtype:'',issueType:'Software',idx:13},
                {issue:'Request Permission',issueSubtype:'',issueType:'Software',idx:10},
                {issue:'Wrong Report',issueSubtype:'',issueType:'Software',idx:11},
                {issue:'OS Format',issueSubtype:'',issueType:'Software',idx:12},

            ];

            issues.forEach(issue=>{

                fb.issueMasterCollection.add({
                    issue: issue.issue,
                    issueType:issue.issueType,
                    issueSubtype: issue.issueSubtype,
                    idx: issue.idx,
                    creationDate: new Date(),
                })
                .then(docRef=>{
                    console.log("docRef ", issue.issue,docRef.id);
                })
                .catch(error=>console.log(error))



            });

        },

        populateIssueSubtypes(){
            let issueSubtypes = [{"IssueSubtype":"Acrobat Reader"},{"IssueSubtype":"Adobe Illustrator"},{"IssueSubtype":"Antivirus"},{"IssueSubtype":"Battery Pack"},{"IssueSubtype":"Botique Web System"},{"IssueSubtype":"Browser"},{"IssueSubtype":"Cable"},{"IssueSubtype":"Cash Register"},{"IssueSubtype":"Cognos"},{"IssueSubtype":"Coin System"},{"IssueSubtype":"Corel"},{"IssueSubtype":"CPU"},{"IssueSubtype":"Data Cable"},{"IssueSubtype":"Data File"},{"IssueSubtype":"Database"},{"IssueSubtype":"Drive Q"},{"IssueSubtype":"Driver"},{"IssueSubtype":"Email"},{"IssueSubtype":"External drive/Hard Disk"},{"IssueSubtype":"HQ Server"},{"IssueSubtype":"Internet/Access Port"},{"IssueSubtype":"IPOS"},{"IssueSubtype":"Jeonsoft"},{"IssueSubtype":"Lan Connection/Network"},{"IssueSubtype":"Landline / DSL"},{"IssueSubtype":"Laptop"},{"IssueSubtype":"Leesys"},{"IssueSubtype":"Mall Hook-up"},{"IssueSubtype":"Map Drive"},{"IssueSubtype":"Memory"},{"IssueSubtype":"Microsoft Applications/Office"},{"IssueSubtype":"Monitor"},{"IssueSubtype":"Motherboard"},{"IssueSubtype":"Old Navision"},{"IssueSubtype":"Operating System"},{"IssueSubtype":"Order Entry"},{"IssueSubtype":"Order Mobile"},{"IssueSubtype":"Pcanywhere"},{"IssueSubtype":"Portal"},{"IssueSubtype":"POS"},{"IssueSubtype":"Power Cable/Supply"},{"IssueSubtype":"Print Server"},{"IssueSubtype":"Printer"},{"IssueSubtype":"Printer Sharing"},{"IssueSubtype":"Remote Desktop Connection"},{"IssueSubtype":"RMS"},{"IssueSubtype":"Sales Backdate"},{"IssueSubtype":"Sales Upload"},{"IssueSubtype":"Scanner"},{"IssueSubtype":"Sharepoint"},{"IssueSubtype":"SI"},{"IssueSubtype":"SOT"},{"IssueSubtype":"Spark"},{"IssueSubtype":"Terminal Service"},{"IssueSubtype":"Test only"},{"IssueSubtype":"UPS"},{"IssueSubtype":"USB"},{"IssueSubtype":"Username & Password "},{"IssueSubtype":"Video File"},{"IssueSubtype":"Web Ordering"},{"IssueSubtype":"Webmail"},{"IssueSubtype":"WebPlm"},{"IssueSubtype":"Wifi Stick"},{"IssueSubtype":"Wireless Connection"},{"IssueSubtype":"Basic Apps for Client( Office,Spark, Antivirus,Driver,Remote app)"},{"IssueSubtype":"Basic Apps for Server ( SQL and others Server Reqt)"},{"IssueSubtype":"Nav 2017"},{"IssueSubtype":"3rd party App - Submarine"},{"IssueSubtype":"3rd party App - Super Mario"},{"IssueSubtype":"3rd party App - FG Helper"},{"IssueSubtype":"Cellphone"},{"IssueSubtype":"Tablet"},{"IssueSubtype":"Handheld Scanner"}]
            issueSubtypes.forEach(subType=>{
                fb.issueSubtypesCollection.add({
                    subType: subType.IssueSubtype,
                })
                .then(()=>{
                    //console.log("docRef ", issue.issue,docRef.id);
                })
                .catch(error=>console.log(error))

            })
        },

        populateDiagnostics(){

            let diagnostics = [{"DiagnosticType":"Hardware","Diagnostic":"Dusty Computer"},{"DiagnosticType":"Hardware","Diagnostic":"Faulty Graphic Card"},{"DiagnosticType":"Hardware","Diagnostic":"For Delivery"},{"DiagnosticType":"Hardware","Diagnostic":"Hardware scratching/Mechanical Failure"},{"DiagnosticType":"Hardware","Diagnostic":"Insufficient power supply"},{"DiagnosticType":"Hardware","Diagnostic":"Intermittent network connection due to wiring;lancard;router,switch;antenna or provider"},{"DiagnosticType":"Hardware","Diagnostic":"Loose cable/bad connection between memory module and motherboard;videocard and motherboard;loose hard disk;faulty RAM"},{"DiagnosticType":"Hardware","Diagnostic":"Net Set up and software Installation"},{"DiagnosticType":"Hardware","Diagnostic":"New Lay out"},{"DiagnosticType":"Hardware","Diagnostic":"No ink"},{"DiagnosticType":"Hardware","Diagnostic":"Physical Damage/End of Life/Wear & Tear"},{"DiagnosticType":"Software","Diagnostic":"Application corrupted"},{"DiagnosticType":"Software","Diagnostic":"Boot Sector Virus"},{"DiagnosticType":"Software","Diagnostic":"Conflict with another network/IP related"},{"DiagnosticType":"Software","Diagnostic":"Conflict with existing application"},{"DiagnosticType":"Software","Diagnostic":"Corrupted due to virus"},{"DiagnosticType":"Software","Diagnostic":"Delivery not updated"},{"DiagnosticType":"Software","Diagnostic":"DLL Missing"},{"DiagnosticType":"Software","Diagnostic":"Download / Upload"},{"DiagnosticType":"Software","Diagnostic":"Driver uninstalled"},{"DiagnosticType":"Software","Diagnostic":"Exe Problem Encountered"},{"DiagnosticType":"Software","Diagnostic":"Expired License"},{"DiagnosticType":"Software","Diagnostic":"File Transfer / Backup"},{"DiagnosticType":"Software","Diagnostic":"Improper closing of software,files or program"},{"DiagnosticType":"Software","Diagnostic":"Incomplete Installation of Software Reqt"},{"DiagnosticType":"Software","Diagnostic":"Insufficient resources"},{"DiagnosticType":"Software","Diagnostic":"Missing NTLDR & Boot.init file"},{"DiagnosticType":"Software","Diagnostic":"Software illegal operation"},{"DiagnosticType":"Software","Diagnostic":"Spam/Spyware"},{"DiagnosticType":"Software","Diagnostic":"Trying to boot from a non bootable device"},{"DiagnosticType":"Software","Diagnostic":"Unable to launch program"},{"DiagnosticType":"Software","Diagnostic":"Unnecessary installed plug ins in browser"},{"DiagnosticType":"Software","Diagnostic":"Wrong Bios Setting"},{"DiagnosticType":"System","Diagnostic":"Back Date"},{"DiagnosticType":"System","Diagnostic":"Database Backup / Restore"},{"DiagnosticType":"System","Diagnostic":"Database Table locking"},{"DiagnosticType":"System","Diagnostic":"Disconnected to System service"},{"DiagnosticType":"System","Diagnostic":"Exceeded  Mailbox Quota"},{"DiagnosticType":"System","Diagnostic":"Exceeded maximum user or permission"},{"DiagnosticType":"System","Diagnostic":"Late/No Posting/encoding/updating"},{"DiagnosticType":"System","Diagnostic":"New User Acct"},{"DiagnosticType":"System","Diagnostic":"Price not Updated"},{"DiagnosticType":"System","Diagnostic":"Security Permission"},{"DiagnosticType":"System","Diagnostic":"Unsynchronize System Time"},{"DiagnosticType":"System","Diagnostic":"Unsynchronize System User  Acct"},{"DiagnosticType":"System","Diagnostic":"Wrong Recipient's delivery address"},{"DiagnosticType":"User","Diagnostic":"Typo Error"},{"DiagnosticType":"User","Diagnostic":"Unable to perform store opening/closing reqt"}]

            diagnostics.forEach(diag=>{

                fb.diagnosticsCollection.add({
                    diagnostic: diag.Diagnostic,
                    diagnosticType:diag.DiagnosticType
                })
                .then(()=>{
                    //console.log("docRef ", issue.issue,docRef.id);
                })
                .catch(error=>console.log(error))

            })


        },

        populateLocations(){

            let locations = [{"Location":"BTQ-CHNTWN"},{"Location":"BTQ-EVRCOM"},{"Location":"BTQ-FARMER"},{"Location":"BTQ-FESTI"},{"Location":"BTQ-FMALL"},{"Location":"BTQ-HARBOR"},{"Location":"BTQ-KCCZAM"},{"Location":"BTQ-MARKET"},{"Location":"BTQ-MARQUE"},{"Location":"BTQ-ROBERM"},{"Location":"BTQ-ROBIMS"},{"Location":"BTQ-ROBLAO"},{"Location":"BTQ-ROBLP"},{"Location":"BTQ-ROBPAS"},{"Location":"BTQ-SMBAC"},{"Location":"BTQ-SMBAG"},{"Location":"BTQ-SMBAT"},{"Location":"BTQ-SMBCD"},{"Location":"BTQ-SMCEB"},{"Location":"BTQ-SMCEB2"},{"Location":"BTQ-SMCLK"},{"Location":"BTQ-SMCLMB"},{"Location":"BTQ-SMDAS"},{"Location":"BTQ-SMDAV"},{"Location":"BTQ-SMEDS"},{"Location":"BTQ-SMFRVW"},{"Location":"BTQ-SMGEN"},{"Location":"BTQ-SMILO"},{"Location":"BTQ-SMLIPA"},{"Location":"BTQ-SMLUC"},{"Location":"BTQ-SMLZR"},{"Location":"BTQ-SMMLA"},{"Location":"BTQ-SMMOA"},{"Location":"BTQ-SMMOL"},{"Location":"BTQ-SMMRL"},{"Location":"BTQ-SMMUN"},{"Location":"BTQ-SMORT"},{"Location":"BTQ-SMROS"},{"Location":"BTQ-SMRSLS"},{"Location":"BTQ-SMRSRO"},{"Location":"BTQ-SMSAN"},{"Location":"BTQ-SMSFP"},{"Location":"BTQ-SMSOU"},{"Location":"BTQ-SMSPAB"},{"Location":"BTQ-SMTAR"},{"Location":"BTQ-SMTAY"},{"Location":"BTQ-SMTUG"},{"Location":"BTQ-SMURD"},{"Location":"BTQ-SMVAL"},{"Location":"BTQ-STALU"},{"Location":"CENTRO-BAN"},{"Location":"CENTRO-CAL"},{"Location":"CENTRO-CAT"},{"Location":"CENTRO-CAU"},{"Location":"CENTRO-DAE"},{"Location":"CENTRO-LEM"},{"Location":"CENTRO-SAN"},{"Location":"CENTRO-SOL"},{"Location":"CENTRO-SRG"},{"Location":"CENTRO-STA"},{"Location":"CENTRO-TUG"},{"Location":"CENTRO-VIR"},{"Location":"DSG-BAJAD"},{"Location":"DSG-DAD"},{"Location":"DSG-DIGOS"},{"Location":"DSG-TAGUM"},{"Location":"DSG-TORIL"},{"Location":"FCDS-CAL"},{"Location":"FCDS-DIGOS"},{"Location":"FCDS-KIDAP"},{"Location":"FCDS-LUPON"},{"Location":"FCDS-MATI"},{"Location":"FCDS-NABUN"},{"Location":"FCDS-PNBO"},{"Location":"FCDS-SANFR"},{"Location":"FCDS-SUPER"},{"Location":"GALX-BOGO"},{"Location":"GALX-MAIN"},{"Location":"GALX-MALL"},{"Location":"GCAG-BUT"},{"Location":"GCAG-CAG"},{"Location":"GCAG-IMALL"},{"Location":"GCAG-MALAY"},{"Location":"GCAG-VAL"},{"Location":"GCAP-CENTAC"},{"Location":"GCAP-DANAO"},{"Location":"GCAP-LAPAZ"},{"Location":"GCAP-MACTAN"},{"Location":"GCAP-PAG"},{"Location":"GCAP-TAC"},{"Location":"GDSG-BAJAD"},{"Location":"GDSG-DAD"},{"Location":"GDSG-TAGUM"},{"Location":"GDSG-TORL"},{"Location":"GGRD-ANTIQ"},{"Location":"GGRD-BAC"},{"Location":"GGRD-BAJAD"},{"Location":"GGRD-CALI"},{"Location":"GGRD-CTBAC"},{"Location":"GGRD-DIGOS"},{"Location":"GGRD-KABAN"},{"Location":"GGRD-KDPWN"},{"Location":"GGRD-KORO"},{"Location":"GGRD-MING"},{"Location":"GGRD-NABUN"},{"Location":"GGRD-PLMLK"},{"Location":"GGRD-PNBO"},{"Location":"GGRD-ROXAS"},{"Location":"GGRD-SNFRA"},{"Location":"GGRD-SOUCT"},{"Location":"GGRD-TAGUM"},{"Location":"GGRD-TORIL"},{"Location":"GMET-MAASN"},{"Location":"GMET-MAND"},{"Location":"GMET-TOL"},{"Location":"KCC-ZAM"},{"Location":"KCDS-GNSAN"},{"Location":"NCDS-MAIN"},{"Location":"NCDS-PAL"},{"Location":"NCDS-TAG"},{"Location":"OUT-ACNDA"},{"Location":"OUT-CRCUIT"},{"Location":"OUT-STAR"},{"Location":"N/A"},{"Location":"ALL STORES"}]
            locations.forEach(loc=>{

                fb.locationsCollection.add({
                    location: loc.Location
                })
                .then(()=>{
                    //console.log("docRef ", issue.issue,docRef.id);
                })
                .catch(error=>console.log(error))

            })
        },

        populateSections(){
            let sections = [{"Section":"Boutique"},{"Section":"Deptstore"},{"Section":"Inhouse"},{"Section":"Main Office"},{"Section":"Satellite"}]
            sections.forEach(section=>{

                fb.sectionsCollection.add({
                    section : section.Section
                })
                .then(()=>{
                    //console.log("docRef ", issue.issue,docRef.id);
                })
                .catch(error=>console.log(error))

            })
        },

        populateSolutionMethods(){

            let methods = [{"Method":"Delivery"},{"Method":"Guide Through Call"},{"Method":"OnSite"},{"Method":"Pull Out"},{"Method":"Remote"},{"Method":"Report to Provider"}]
            methods.forEach(method=>{

                fb.solutionMethodsCollection.add({
                    method : method.Method
                })
                .then(()=>{
                    //console.log("docRef ", issue.issue,docRef.id);
                })
                .catch(error=>console.log(error))

            })
        },

        populateSolutions(){
            let solns = [{"Solution":"Activate","Idx":1},{"Solution":"Add/Remove","Idx":1},{"Solution":"Archive","Idx":1},{"Solution":"Backup/Restore","Idx":1},{"Solution":"Clone","Idx":1},{"Solution":"Configure","Idx":1},{"Solution":"Connect","Idx":1},{"Solution":"Create","Idx":1},{"Solution":"Delete","Idx":1},{"Solution":"Download","Idx":1},{"Solution":"Format","Idx":1},{"Solution":"Install/Uninstall","Idx":1},{"Solution":"Repair","Idx":1},{"Solution":"Reset up","Idx":1},{"Solution":"Set up","Idx":1},{"Solution":"Update","Idx":1},{"Solution":"Upload","Idx":1},{"Solution":"Reprint","Idx":1}]
            solns.forEach(soln=>{

                fb.solutionsCollection.add({
                   solution : soln.Solution,
                   idx: soln.Idx,
                   creationDate: new Date(),
                   solutionType:''
                })
                .then(()=>{
                    //console.log("docRef ", issue.issue,docRef.id);
                })
                .catch(error=>console.log(error))

            })
        }
    
    }
}
</script>
<style scoped>

</style>